import axios from 'axios';
import { USERREPORTSETTINGS } from 'utils/constants';
import { trackPromise } from 'react-promise-tracker';
import { SaveUpdateReportSettings } from 'models/request';
import { OptionsFiltersPrefererence, SaveUpdateReportSettingsResponse } from 'models/userReportSettings';

/**
 *  Save or Update Repots Settings
 * @param {Object} payload
 * @param {number} payload.idReport
 * @param {number} payload.idFolder
 * @param {string} payload.settingType
 * @param {ReportFilter[]} payload.filtersJson
 * @param {{columnHeader: string, columnName: string}[]} payload.selectItemsJson
 * @return {Promise<AxiosResponse>}
 */
const saveOrUpdateReportSettings = (payload: SaveUpdateReportSettings) =>
  trackPromise(axios.post<SaveUpdateReportSettingsResponse>(`${USERREPORTSETTINGS}/saveOrUpdate`, payload), 'modal');

const loadFiltersPreference = (idFolder: number, idReport: number) => {
  return trackPromise(
    axios.post<OptionsFiltersPrefererence[]>(`${USERREPORTSETTINGS}/loadByIdUserAndIdReportAndIdFolder`, {
      idReport,
      idFolder,
    }),
    'module',
  );
};

const deleteFiltersPreference = (idUserReportSetting: number) => {
  return trackPromise(
    axios.post(`${USERREPORTSETTINGS}/deleteById`, {
      idUserReportSetting,
    }),
    'modal',
  );
};

export default {
  saveOrUpdateReportSettings,
  loadFiltersPreference,
  deleteFiltersPreference,
};
